<div id="content-section">
    <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
        <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
            <div class="sticky-top">
                <small class="bg-white">
                  <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
                    <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
                  </a>
                </small>
            </div>
            <div class="text-center pagination-small-margin pagination-center">
                <pagination
                    (pageChanged)="search($event, null)"
                    class="pagination-sm"
                    [boundaryLinks]="true"
                    [totalItems]="count"
                    [maxSize]="5"
                    [itemsPerPage]="searchParams.per_page"
                    [(ngModel)]="searchParams.page"
                    previousText="&lsaquo;"
                    nextText="&rsaquo;"
                    firstText="&laquo;"
                    lastText="&raquo;"
                ></pagination>
            </div>
            <div class="text-center pt-1">
                <app-pagination-count
                    [count]="count"
                    singularName="Bill"
                    pluralName="Bills"
                ></app-pagination-count>
            </div>
            <hr class="my-1" />
            <div class="clearfix"></div>
            <div class="sticky-top bg-white">
                <h5 class="pt-2">
                <div class="pull-right float-right">
                    <app-clear-search-btn [searching]="searching" (onClick)="clearSearch()"></app-clear-search-btn>
                </div>
                <span>
                    Search&nbsp;&nbsp;
                    <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search(null, true) : ''">
                        <i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i>
                    </a>
                </span>
                </h5>
                <hr class="my-1" />
            </div>
            <div class="row">
                <div class="col-md-12">
                    <form>
                        <div class="form-group">
                            <label for="bill-id">Bill ID:</label>
                            <input class="form-control" type="number" id="bill-id" name="bill-id" [(ngModel)]="searchParams['search[id]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }" placeholder="Enter bill ID">
                        </div>
                        <div class="form-group">
                            <label for="bill-type">Bill type:</label>
                            <select class="form-control" id="bill-type" [(ngModel)]="searchParams.bill_type_id" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]="billType.value" *ngFor="let billType of searchOptions.bill_types">{{billType.label}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="billing-user">Billed By User:</label>
                            <select class="form-control" id="billing-user" [(ngModel)]="searchParams['search[user_id]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="billUser.id" *ngFor="let billUser of searchOptions.bill_users">{{billUser.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="matter-name">Matter Name/Number:</label>
                            <app-matter-search id="matter-name" [placeholder]="'Search and select'" (clearMatter)="searchParams['search[matter_id]'] = undefined" [matterId]="searchParams['search[matter_id]']" [small_input]="false" (matter_id)="searchParams['search[matter_id]']=$event"></app-matter-search>
                        </div>
                        <div class="form-group">
                            <app-multi-select-search
                                label="Matter Types"
                                [searchOptions]="searchOptions.matter_types || []"
                                [selectedOptions]="searchParams['search[matter_type_id]'] || []"
                                (selected)="searchParams['search[matter_type_id]'] = $event">
                            </app-multi-select-search>
                        </div>
                        <div class="form-group">
                            <label for="contact-name">Client Name:</label>
                            <app-contact-search id="contact-name" [contactId]="searchParams['search[contact_id]']" (clearContact)="searchParams['search[contact_id]'] = undefined" [placeholder]="'Search and select'" [small_input]="false" (contact_id)="searchParams['search[contact_id]']=$event"></app-contact-search>
                        </div>
                        <div class="form-group">
                            <label for="amount">Amount:</label>
                            <input class="form-control" type="text" id="amount" name="amount" [(ngModel)]="searchParams['search[amount]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-group">
                            <label for="entry-group">Entry Group:</label>
                            <input class="form-control" type="number" id="entry-group" name="entry-group" [(ngModel)]="searchParams.entry_group_ids" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="from-date">Date From:</label>
                                <input type="text" class="form-control" #FilterFromDate="ngModel" name="from-date" [(ngModel)]="searchParams['search[date_from]']" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams['search[date_from]'] = $event" id="fromDate" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="to-date">Date To:</label>
                                <input type="text" class="form-control" #FilterToDate="ngModel" name="to-date" [(ngModel)]="searchParams['search[date_to]']" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams['search[date_to]'] = $event" id="toDate" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="order-by">Order By:</label>
                                <select class="form-control" id="order-by" [(ngModel)]="searchParams.order_by" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                    <option value=""></option>
                                    <option *ngFor='let orderBy of searchOptions.order_by' [value]='orderBy.value'>{{orderBy.label}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="in-order-of">In Order Of:</label>
                                <select class="form-control" id="in-order-of" [(ngModel)]="searchParams.order_direction" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                    <option value=""></option>
                                    <option *ngFor='let orderDirection of searchOptions.order_direction' [value]='orderDirection.value'>{{orderDirection.label}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'all'">
                                <input [checked]="searchParams.reversal == 'all'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">All</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'hide_reversed'">
                                <input [checked]="searchParams.reversal == 'hide_reversed'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">Hide Reversed</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'only_reversed'">
                                <input [checked]="searchParams.reversal == 'only_reversed'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">Only Reversed</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-checkbox" (click)="searchParams['search[weekly_fees]'] = !searchParams['search[weekly_fees]']">
                                <input type="checkbox" class="custom-control-input" [checked]="searchParams['search[weekly_fees]']" [(ngModel)]="searchParams['search[weekly_fees]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }"/>
                                <label class="custom-control-label">User's Weekly Fees</label>
                            </div>
                            <div class="custom-control custom-checkbox" (click)="searchParams['search[others_billings]'] = !searchParams['search[others_billings]']">
                                <input type="checkbox" class="custom-control-input" [checked]="searchParams['search[others_billings]']" [(ngModel)]="searchParams['search[others_billings]']"  #ctrl="ngModel" [ngModelOptions]="{ standalone: true }"/>
                                <label class="custom-control-label">Others Billings for User's Matters</label>
                            </div>
                            <div class="custom-control custom-checkbox" (click)="searchParams.exclude_names = !searchParams.exclude_names">
                                <input type="checkbox" class="custom-control-input" [checked]="searchParams.exclude_names" [(ngModel)]="searchParams.exclude_names" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }"/>
                                <label class="custom-control-label">Exclude Names</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <app-search-btn [searching]="searching" (onClick)="searchParams.page = 1; search(null, true)"></app-search-btn>
                        </div>
                        <div class="form-group">
                            <a class="btn btn-primary btn-sm" style="width: 100%" type="button" target='_blank' [href]="'/' + downloadCsvUrl">
                                Download CSV
                            </a>
                        </div>
                    </form>
                    <h4>
                        Total:&nbsp;
                        <app-badge badgeType="info">
                            {{total | currency: 'USD':'symbol':'1.2-2'}}
                        </app-badge>
                    </h4>
                </div>
            </div>
        </div>
        <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px;">
            <div class="container-shadow px-3 pb-4">
                <h2 class="pt-4 text-center">Bills</h2>
                <hr class="mt-1 mb-2" />

                <!-- Stats Cards Row -->
                <div class="stats-row px-4 pt-3">
                    <div class="stat-card">
                        <i class="fas fa-file-invoice stat-icon"></i>
                        <div class="stat-label">Bills Per Page</div>
                        <select class="stat-value per-page-select" [(ngModel)]="searchParams.per_page" (change)="searchParams.page = 1; search(null, true)">
                            <option [value]="25">25</option>
                            <option [value]="50">50</option>
                            <option [value]="100">100</option>
                            <option [value]="200">200</option>
                            <option [value]="500">500</option>
                        </select>
                    </div>
                    <div class="stat-card">
                        <i class="fas fa-copy stat-icon"></i>
                        <div class="stat-label">Total Pages</div>
                        <div class="stat-value text-info">{{count ? Math.ceil(count / searchParams.per_page) : 0}}</div>
                    </div>
                    <div class="stat-card">
                        <i class="fas fa-dollar-sign stat-icon"></i>
                        <div class="stat-label">Total Amount</div>
                        <div class="stat-value text-success">{{total | currency: 'USD':'symbol':'1.2-2'}}</div>
                    </div>
                </div>

                <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                    <table class="table table-striped" style="transform: rotateX(180deg);">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th></th>
                                <th>Group</th>
                                <th>Matter</th>
                                <th>Lead</th>
                                <th>Type</th>
                                <th>Description</th>
                                <th>Category</th>
                                <th>Date</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let bill of bills" class="bill-row">
                                <td><a [ngClass]="{'lightblue': bill.color_conditions.light_colored}" [href]="'/bills/' + bill.id">{{bill.id}}</a></td>
                                <td><a [href]="bill.tree_link_path"><i class="fas fa-tree"></i></a></td>
                                <td><a [ngClass]="{'lightblue': bill.color_conditions.light_colored}" [href]="'/entry_groups/' + bill.entry_group_id">{{bill.entry_group_id}}</a></td>
                                <td><a [routerLink]="'/matters/' + bill.matter_id">{{bill.matter.number}}</a> {{bill.matter_name}}</td>
                                <td [ngClass]="{'text-muted': bill.color_conditions.light_colored}"><a [href]="bill.lead_link_path">{{bill.lead}}</a></td>
                                <td><a [ngClass]="{'lightblue': bill.color_conditions.light_colored}" [href]="'/bill_types/' + bill.bill_type_id">{{bill.bill_type.name}}</a></td>
                                <td [ngClass]="{'text-muted': bill.color_conditions.light_colored}" [innerHTML]="bill.description | safeHtml"></td>
                                <td [ngClass]="{'text-muted': bill.color_conditions.light_colored}">{{bill.category}}</td>
                                <td [ngClass]="{'text-muted': bill.color_conditions.light_colored}">{{bill.created_at_date}}</td>
                                <td [ngClass]="{'text-danger': bill.negative_amount && !bill.color_conditions.light_colored, 'lightsalmon': bill.negative_amount && bill.color_conditions.light_colored}" class="text-right">
                                    <span *ngIf="bill.amount">{{bill.amount | currency: 'USD':'symbol':'1.2-2'}}</span>
                                    <span *ngIf="!bill.amount"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>
